module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "textcenter1"
  }, [_c('b', [_vm._v("GRANDMA’S SONG")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenterwithspace1"
  }, [_vm._v("When Grandma cries")]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_vm._v("Tears fall like bombs")]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_vm._v("Exploding in my ears.")]), _vm._v(" "), _c('p', {
    staticClass: "textcenterwithspace1"
  }, [_vm._v("Her heartbeat slows")]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_vm._v("The drum strikes low")]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_vm._v("Pounding out hard years,")]), _vm._v(" "), _c('p', {
    staticClass: "textcenterwithspace1"
  }, [_vm._v("Yet in the sadness")]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_vm._v("The pulse of gladness")]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_vm._v("The path to wisdom true.")]), _vm._v(" "), _c('p', {
    staticClass: "textcenterwithspace1"
  }, [_vm._v("When Grandma cries")]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_vm._v("Tears fall like rain")]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_vm._v("And life, it springs anew.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c0e07e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/illu_a.vue
// module id = 81
// module chunks = 0